export function joinPath(...paths) {
  return paths.map((v, i) => {
    if (i < paths.length - 1 && v.endsWith('/')) {
      v = v.substr(0, v.length - 1)
    }
    return v;
  }).filter(v => v != '').join('/');
}

